import { ACCOUNTS_PATH } from './navigation';

const indexComponent = require('./AccountsContainer');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: ACCOUNTS_PATH,
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/index.js